/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { forwardRef } from 'react';
import { StyledButton, StyledButtonContent, StyledIcon, StyledProgressIndicator } from './index.styles.js';
import {} from '../icon/index.js';
import {} from '@oneaudi/unified-web-alpha-common';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const hasHref = (props) => {
    return typeof props.href === 'string';
};
export const TextButton = forwardRef((props, ref) => {
    const { variant, size = 'md', iconPosition, icon, children, className, 'aria-label': ariaLabel, id, isFullWidth, isLoading, margin, title, role } = props;
    const iconElement = icon && (React.createElement(StyledIcon, { name: icon, size: props.size === 'xs' ? 'xs' : 's' }));
    const baseProps = {
        variant,
        ref,
        size,
        isFullWidth,
        className,
        'aria-label': ariaLabel,
        margin,
        id,
        title,
        role
    };
    const content = (React.createElement(React.Fragment, null,
        isLoading && (React.createElement(StyledProgressIndicator, { variant: "spinner", type: "infinite", colorScheme: "idle", size: props.size === 'xs' ? 'sm' : 'md' })),
        React.createElement(StyledButtonContent, { isLoading: isLoading, "aria-hidden": isLoading, size: size },
            iconPosition === 'leading' && iconElement,
            children,
            iconPosition === 'trailing' && iconElement)));
    if (hasHref(props)) {
        const { onClick, target, rel, href, onKeyDown } = props;
        return (React.createElement(StyledButton, { ...baseProps, ...pickDataProps(props), as: "a", href: href, rel: rel, target: target, isLoading: isLoading, onClick: onClick, onKeyDown: onKeyDown }, content));
    }
    const { disabled, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'aria-live': ariaLive, type = 'button', onClick, onKeyDown, selected } = props;
    return (React.createElement(StyledButton, { ...baseProps, ...pickDataProps(props), as: "button", onClick: onClick, onKeyDown: onKeyDown, disabled: disabled || isLoading, "aria-live": ariaLive, isLoading: isLoading, "aria-disabled": disabled || isLoading, "aria-controls": ariaControls, "aria-expanded": ariaExpanded, "aria-haspopup": ariaHasPopup, type: type, "$selected": selected }, content));
});
TextButton.displayName = 'TextButton';
//# sourceMappingURL=index.js.map